<template>
    <div class="course_wrapper">
        
        <p class="little-label">选课：</p>
        <CourseCreditTable ref="table" v-model="score_price" :authData="courseData"/>
        <div style="height: 8px;"></div>
        <div class="line-dot"></div>
        <p class="little-label">已勾选：{{ selections.length }}节课</p>

    </div>
</template>

<script>
    import CourseCreditTable from '@/components/CourseCredit/CourseCreditTable'
    export default {
        name: 'renew',
        components: {
            CourseCreditTable
        },
        inject: ['setCredit', 'changeMainPrice'],
        props: {
            courseData: {
                type: Array,
                default: () => ([])
            }
        },
        data: () => ({
            score_price: {
                score: 0,
                price: 0
            },
            selections: []
        }),
        computed: {
            
        },
        watch: {
            courseData: {
                handler (val) {
                    this.$nextTick(() => {
                        let ids = this.$route.query.courseIds
                        if(ids) {
                            ids = atob(ids).split(',')
                        }
                        this.$refs.table.selectByIds(ids)
                    })
                },
                immediate: true
            },
            score_price:{
                handler (val) {
                    this.setCredit(val.score)
                    this.changeMainPrice(val.price)
                    this.selections = this.$refs.table?.getSelections() || []
                },
                immediate: true
            }
        },
        mounted() {
            
        },
        methods: {
            getSelections () {
                return this.$refs.table.getSelections()
            }
        }
    }
</script>

<style scoped>
.course_wrapper {
    background-color: rgb(247, 248, 250);
    padding: 10px;
    padding-bottom: 0;
}

.line-dot {
    border-bottom: 1px dashed rgb(136, 137, 138);
    clear: both;
    padding-top: 10px;
    margin-bottom: 10px;
}
.little-label {
    font-size: 12px;
    color: rgb(111, 111, 113);
    clear: both;
    padding: 0 0 4px;
    margin: 0;
}
</style>